const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');
const _ = require('lodash');

class RichRelevanceCategoryInstrumentationController extends RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService, settings) {
        // opt-out from state change notifications.
        // category changes are handled using scope changes.
        const baseControllerConfig = {
            instrumentOnStateChange: false,
        };

        super($scope, $window, featureService, richRelevanceService, baseControllerConfig);
        this.richRelevanceService = richRelevanceService;
        this.selectedCategory = {};
        this.lastInstrumentedPageNumber = -1; // will be updated on first show.
        this.settings = settings;
    }

    sendInstrumentation() {
        this.setAisleOrCategory(this.currentCategory);
    }

    setAisleOrCategory(currentCategory) {
        // If we're requesting placements server-side, don't send the p13n call on Browse except specials category.
        if (this.settings.richRelevance.removeDuplicatedProducts && (currentCategory && !currentCategory.IsSpecial)) {
            return;
        }
        // current category is reinitialized when user clicks on items (view item details) .etc.
        // we dont want to send instrumentation if the actual values didn't change.
        if (!currentCategory || (_.isEqual(currentCategory, this.selectedCategory) && this.lastInstrumentedPageNumber === this.pageNumber)) {
            return;
        }
        this.selectedCategory = currentCategory;
        this.setCategoryIdAndName(currentCategory);
    }

    setCategoryIdAndName(category) {
        this.richRelevanceService.clearPlacements();

        this.richRelevanceService.getInformation()
            .then(() => {
                if (category.NodeId && !category.IsSpecial) {
                    window.R3_CATEGORY = new window.r3_category(); // eslint-disable-line new-cap
                    window.R3_CATEGORY.setId(category.NodeId); // category ID must match a category id as passed in catalog feed
                    window.R3_CATEGORY.setName(category.Description); // category name as it should be displayed to customers, overrides the value provided in the catalog feed for this category ID
                } else if (category.RichRelevanceId) {
                    window.R3_CATEGORY = new window.r3_category(); // eslint-disable-line new-cap
                    window.R3_CATEGORY.setId(category.RichRelevanceId);
                    window.R3_CATEGORY.setName(category.Description);
                } else {
                    // if there is no category id or it's a special category, call generic page request.
                    window.R3_GENERIC = new window.r3_generic(); // eslint-disable-line new-cap
                }
                if (!this.settings.richRelevance.removeDuplicatedProducts && (this.pageNumber === undefined || this.pageNumber < 2)) {
                    // only add placements if it's infinite scroll (pageNumber === undefined)
                    // or page 1 (pageNumber === 1)
                    this.addPlacementTypesIfEnabled();
                }
                this.lastInstrumentedPageNumber = this.pageNumber;
                window.rr_flush_onload();
                window.r3();
            });
    }

    setPlacementIdsForSpecialsGroup(category) {
        this.placementIds = this.richRelevanceService.getPlacementIdsForSpecialsGroup(category);
    }

    setPlacementIdsForCategory(category) {
        if (category && category.NodeLevel) {
            this.placementIds = this.richRelevanceService.getPlacementByCategoryLevel(category.NodeLevel);
        }
    }

    $onChanges(changes) {

        if (changes.currentCategory || (changes.pageNumber && changes.pageNumber.currentValue !== this.lastInstrumentedPageNumber)) {
            const category = changes.currentCategory ? changes.currentCategory.currentValue : this.selectedCategory;

            if (category && category.RichRelevanceId) {
                this.setPlacementIdsForSpecialsGroup(category);
            } else if (category && category.NodeId === this.richRelevanceService.mySpecialsGroupId) {
                this.placementIds = this.richRelevanceService.mySpecialsPlacement;
            } else {
                this.setPlacementIdsForCategory(category);
            }
            this.setAisleOrCategory(category);
        }
    }
}

const richRelevanceCategoryInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Settings', RichRelevanceCategoryInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
        currentCategory: '<',
        pageNumber: '<',
        isSpecialsGroup: '=',
    },
};

module.exports = {
    RichRelevanceCategoryInstrumentationController,
    richRelevanceCategoryInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-category-instrumentation.component.js